function Badge({ children }) {
  return <div className="badge badge-sm normal-case shrink-0">{children}</div>;
}

export default Badge;
